import React from "react";
import {  useParams } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import '@fontsource/roboto';


const useStyles = makeStyles((theme )=> ({
  img:{
    maxWidth: '80%'
  },
  li:{
    paddingBottom: '10px'
  }
}));

export default function PostSurvey(props){
  let {postno, condition } = useParams();
  const classes=useStyles();
  return(
    <div>
          <div>
            <div style={{padding: '40px', backgroundColor: 'white', paddingBottom: '100px', textAlign:'center'}}>
                <iframe title='final survey' src="https://docs.google.com/forms/d/e/1FAIpQLSdGdr5lch4Cm3WvieUvsA5gHhjlZH19qruObPU_sFiyf15A1A/viewform?embedded=true" style={{width:"640px", height:"673px", frameBorder:"0", marginHeight:"0", marginWidth:"0"}} >Loading…</iframe>
              </div>
          </div>
      </div>
  )

}
